module.exports = __webpack_public_path__ + "static/img/top-bg.9e23fdf3.png";